import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  setBodyGradient,
  setBorderRadius,
  setBorderStroke,
  setBoxLayout,
  setIconColor,
  setMonoChrome,
  setThemeColor,
} from "../../Redux/actions/settingsActions";

const CommonSetting = ({ selectedMode, isOpen }) => {
  // {/* x---------------------------------x Use Dispatch From React-Redux x---------------------------------x */ }
  const dispatch = useDispatch();

  // {/* x---------------------------------x All Setting Data Use From LocalStorage x---------------------------------x */ }
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "Bluelight");
  const [borderStroke, setBorderStrokeState] = useState(localStorage.getItem("borderStroke") || "svgstroke-a");
  const [boxLayout, setBoxLayoutState] = useState(localStorage.getItem("boxLayout") || "");
  const [monochrome, setMonochromeState] = useState(localStorage.getItem("monochrome") || "");
  const [borderRadius, setBorderRadiusState] = useState(localStorage.getItem("borderRadius") || "");
  const [iconColor, setIconColorState] = useState(localStorage.getItem("iconColor") || "");
  const [gradientColor, setGradientColorState] = useState(localStorage.getItem("gradientColor") || "");

  useEffect(() => {
    // {/* x---------------------------------x Use Dispatch for All Setting Data x---------------------------------x */ }
    dispatch(setThemeColor(theme));
    dispatch(setBorderStroke(borderStroke));
    dispatch(setBoxLayout(boxLayout));
    dispatch(setMonoChrome(monochrome));
    dispatch(setBorderRadius(borderRadius));
    dispatch(setIconColor(iconColor));
    dispatch(setBodyGradient(gradientColor));
    setBoxLayoutState("");

    // x---------------------------------x Store settings in localStorage  x---------------------------------x
    localStorage.setItem("theme", theme);
    localStorage.setItem("borderStroke", borderStroke);
    localStorage.setItem("boxLayout", boxLayout);
    localStorage.setItem("monochrome", monochrome);
    localStorage.setItem("borderRadius", borderRadius);
    localStorage.setItem("iconColor", iconColor);
    localStorage.setItem("gradientColor", gradientColor);
  }, [theme, borderStroke, boxLayout, monochrome, borderRadius, iconColor, gradientColor, dispatch]);


  // x---------------------------------x All Setting Modules Function [------> Start] x---------------------------------x

  const handleStrokeChange = (e) => {
    setBorderStrokeState(e.target.value);
  };

  const toggleBodyGradient = () => {
    setGradientColorState(gradientColor === "bg-gradient" && selectedMode !== "dark" ? "bg-body" : "bg-gradient");
  };

  const toggleMonochrome = () => {
    setMonochromeState(monochrome === "" ? "monochrome" : "");
  };

  const toggleBorderRadius = () => {
    setBorderRadiusState(borderRadius === "" ? "radius-0 rounded-none" : "");
  };

  const toggleIconColor = () => {
    setIconColorState(iconColor === "" ? "icon-color" : "");
  };

  const toggleCardShadow = () => {
    const elements = document.getElementsByClassName("card-body");
    const isChecked = document.getElementById("BoxShadow").checked;

    Array.from(elements).forEach((element) => {
      isChecked ? element.classList.add("shadow-active") : element.classList.remove("shadow-active");
    });
  };

  const toggleTheme = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.setAttribute("data-bs-theme", element.getAttribute("data-bs-theme") === "none" ? "dark" : "none");
    }
  };

  const toggleSidebarDark = () => {
    toggleTheme("sidebar");
  };

  const toggleHeaderDark = () => {
    toggleTheme("commonNav");
  };

  // x---------------------------------x All Setting Modules Function [------> End] x---------------------------------x

  return (
    <div
      className={`themeSetting bg-body z-50 ${isOpen ? "tblock " : "thidden"} text-dark`}>
      <div className="shadow-md rounded-b-2xl p-4 w-full mt-2">
        <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-2">
          {/* x---------------------------------x Theme Color Section x---------------------------------x */}
          <div className="theme_colors">
            <h6 className="font-semibold mb-2">Set Theme Color</h6>
            <ul className="choose-skin list-none mb-0 grid grid-cols-5 gap-4  text-center">
              {[
                { color: "ValenciaRed", hex: "#d63b38" },
                { color: "SunOrange", hex: "#f7a614" },
                { color: "AppleGreen", hex: "#5bc43a" },
                { color: "CeruleanBlue", hex: "#00b8d6" },
                { color: "Mariner", hex: "#0066fe" },
                { color: "PurpleHeart", hex: "#6238b3" },
                { color: "Bluelight", hex: "#1814F3" }
              ].map(({ color, hex }) => (
                <li
                  key={color}
                  className=""
                  data-theme={color}
                  onClick={() => setTheme(color)}
                >
                  <div
                    style={{ "--dashbanker-theme-color": hex }}
                    className={`rounded-full ${theme === color ? 'active' : ''}`}
                  ></div>
                </li>
              ))}
            </ul>
          </div>
          {/* x---------------------------------x Other Settings [ Icon Border Stroke OR Layout Section Light/Dark ] x---------------------------------x */}
          <div className="other_section md:justify-self-center">
            {/* x---------------------------------x Icon Border Stroke x---------------------------------x */}
            <div className="mb-4">
              <h6 className="font-semibold mb-2">Icon Border Stroke</h6>
              <div className="flex gap-4 lg:gap-2 lg:flex-nowrap flex-wrap">
                {["svgstroke-a", "svgstroke-b", "svgstroke-c"].map((stroke, index) => (
                  <div key={stroke}>
                    <input
                      onChange={handleStrokeChange}
                      type="radio"
                      className="hidden peer"
                      name="stroke"
                      id={`Stroke_${index}`}
                      value={stroke}
                    />
                    <label
                      className="cursor-pointer border border-primary-500 rounded-md px-2 py-1 peer-checked:text-white peer-checked:bg-primary"
                      htmlFor={`Stroke_${index}`}
                    >
                      Stroke {index + 1}
                    </label>
                  </div>
                ))}
              </div>
            </div>
            {/* x---------------------------------x Layout Section Light/Dark [SideBar/Header] x---------------------------------x */}
            <div className="mb-4">
              <h6 className="font-semibold mb-2">Layout Section Light/Dark</h6>
              <ul className="list-none flex flex-wrap">
                <li className="me-2 mb-2">
                  <input
                    type="radio"
                    name="mode"
                    className="hidden"
                    id="Sidebar_dark"
                    onClick={toggleSidebarDark}
                  />
                  <label className="cursor-pointer border border-primary-500 rounded-md px-2 py-1 peer-checked:text-white peer-checked:bg-primary" htmlFor="Sidebar_dark">
                    Sidebar
                  </label>
                </li>
                <li>
                  <input
                    type="radio"
                    name="mode"
                    className="hidden"
                    id="Header_dark"
                    onClick={toggleHeaderDark}
                  />
                  <label className="cursor-pointer border border-primary-500 rounded-md px-2 py-1 peer-checked:text-white peer-checked:bg-primary" htmlFor="Header_dark">
                    Header
                  </label>
                </li>
              </ul>
            </div>
          </div>
          {/* x---------------------------------x Additional Toggles x---------------------------------x */}
          <div className="flex flex-col gap-4 xl:col-span-2 md:justify-self-center">
            {[
              { label: "Body Gradient", onClick: toggleBodyGradient, id: "BodyGradient" },
              { label: "Monochrome Mode", onClick: toggleMonochrome, id: "Monochrome" },
              { label: "No Border Radius", onClick: toggleBorderRadius, id: "BorderRadius" },
              { label: "Set Icon Color", onClick: toggleIconColor, id: "IconColor" },
              { label: "Set Card Shadow", onClick: toggleCardShadow, id: "BoxShadow" }
            ].map(({ label, onClick, id }) => (
              <div key={id} className="flex items-center">
                <input
                  className="h-4 w-4 rounded checked:bg-red-900"
                  type="checkbox"
                  id={id}
                  onClick={onClick}
                />
                <label className="form-check-label ml-2" htmlFor={id}>
                  {label}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonSetting;
